// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import TerceraCheckBoxGroupTemplate from '@front/templates/TerceraCheckBoxGroupTemplate.html';
import { ContainerControl } from './ContainerControl';
export class TerceraCheckBoxGroup extends ContainerControl {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.DataArrayChanged = new CustomEvent();
        this.observe('dataArray', this.onDataArrayChanged);
    }
    oncomplete() {
        super.oncomplete();
        this.scroll = HtmlScroll.addScroll(this.find('ul'));
    }
    dispose() {
        var _a;
        (_a = this.scroll) === null || _a === void 0 ? void 0 : _a.destroy();
        super.dispose();
    }
    onDataArrayChanged(newVal) {
        this.DataArrayChanged.Raise(this, newVal);
    }
}
ContainerControl.extendWith(TerceraCheckBoxGroup, {
    data: function () {
        return {
            width: 198,
            height: 50,
            dataArray: null
        };
    },
    template: TerceraCheckBoxGroupTemplate
});
